module.exports = __webpack_public_path__ + "static/img/7.c8813ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/fcw/7.jpg
// module id = 0xUf
// module chunks = 1